export class LoggingAnalyticsHandler {
  trackPageView(url) {
    console.log('Analytics page view:', url);
  }
}

export class GoogleAnalyticsHandler {
  trackPageView(canonicalPath, previousPath) {
    // GA4 property. Manually send page_view events
    // https://developers.google.com/analytics/devguides/collection/gtagjs/single-page-applications
    // Note 1: You should turn "Enhanced measurement" off.
    //         It attaches own listeners to elements and that breaks in-app navigation.
    // Note 2: If previousPath is null (just after page load), gtag script sends page_view event automatically.
    //         Only in-app navigation needs to be sent manually from SPA.
    // Note 3: Timeout is needed because gtag script picks up <title>,
    //         and location change event happens before initial rendering.
    if (previousPath && window.gtag) {
      window.setTimeout(() => {
        window.gtag('event', 'page_view', {
          page_path: canonicalPath,
        });
      }, 300);
    }
  }
}

// IMPORTANT: There should only be ONE instance of this handler in your app
export class GoogleTagManagerHandler {
  // Prevents duplicate tracking in case of multiple instances
  static hasTrackedInitialPageView = false;
  
  trackPageView(canonicalPath, previousPath) {
    // Skip if dataLayer isn't available
    if (!window.dataLayer) return;
    
    // For initial page view: let GTM container script handle it
    // For subsequent navigation: manually track it
    if (previousPath) {
      // Use setTimeout to ensure DOM has updated
      window.setTimeout(() => {
        // Track SPA navigation with custom event name to avoid conflict with 
        // the automatic page_view from the GTM container
        window.dataLayer.push({
          event: 'spa_navigation',
          page_title: document.title,
          page_location: window.location.href,
          page_path: window.location.pathname
        });
      }, 300);
    }
  }
}
